module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/soudan_online@2x-e4b4f8df19802aa015bee64835adc210.webp";